<p-toast />

<main class="flex w-full max-w-full flex-col items-center px-4 py-10 min-w-0 sm:px-6">
  <div class="flex w-full max-w-[480px] flex-col items-center gap-6">
    <h1 class="text-section-header w-full text-center" [style.color]="primaryColor()">
      {{ tProfile('change_password_title') }}
    </h1>

    @if (!loading()) {

      <form
        [formGroup]="form"
        class="flex w-full flex-col gap-4 rounded-lg bg-neutral-50 p-6 sm:gap-6"
      >

        <!-- Nueva contraseña -->
        <div class="flex w-full flex-col gap-1">
          <label for="newPassword" class="text-label text-neutral-700">
            {{ tForms('input_new_pass') }}
          </label>
          <div
            class="recover-input-wrap"
            [class.recover-input-error]="form.get('newPassword')?.invalid && form.get('newPassword')?.touched"
          >
            <mat-icon class="recover-input-icon" aria-hidden="true">lock_outline</mat-icon>
            <input
              id="newPassword"
              class="recover-input"
              [type]="showPassword() ? 'text' : 'password'"
              formControlName="newPassword"
              [placeholder]="tForms('placeholder_new_pass_placeholder')"
              autocomplete="off"
            />
            <mat-icon
              class="recover-input-suffix cursor-pointer"
              role="button"
              tabindex="0"
              [attr.aria-label]="showPassword() ? tForms('aria_hide_password') : tForms('show_psw')"
              (click)="togglePasswordVisibility()"
              (keydown.enter)="togglePasswordVisibility()"
            >
              {{ showPassword() ? 'visibility_off' : 'visibility' }}
            </mat-icon>
          </div>

          @let pwdCtrl = form.get('newPassword');
          @if (pwdCtrl?.touched && (pwdCtrl?.value ?? '').length > 0) {
            @let pwdVal = pwdCtrl?.value ?? '';
            <div class="mt-1 flex flex-col gap-1">
              <p
                class="text-label"
                [class.text-success-600]="pwdVal.length >= 8"
                [class.text-error-600]="pwdVal.length < 8"
              >
                {{ pwdVal.length >= 8 ? '✓' : '✗' }} {{ tMsg('error_min_8_chars') }}
              </p>
              <p
                class="text-label"
                [class.text-success-600]="!pwdCtrl?.hasError('bothCase')"
                [class.text-error-600]="pwdCtrl?.hasError('bothCase')"
              >
                {{ !pwdCtrl?.hasError('bothCase') ? '✓' : '✗' }} {{ tMsg('error_both_case') }}
              </p>
              <p
                class="text-label"
                [class.text-success-600]="!pwdCtrl?.hasError('hasNumber')"
                [class.text-error-600]="pwdCtrl?.hasError('hasNumber')"
              >
                {{ !pwdCtrl?.hasError('hasNumber') ? '✓' : '✗' }} {{ tMsg('error_has_number') }}
              </p>
              <p
                class="text-label"
                [class.text-success-600]="!pwdCtrl?.hasError('hasSpecialChar')"
                [class.text-error-600]="pwdCtrl?.hasError('hasSpecialChar')"
              >
                {{ !pwdCtrl?.hasError('hasSpecialChar') ? '✓' : '✗' }} {{ tMsg('error_has_special_char') }}
              </p>
            </div>
          }
        </div>

        <!-- Confirmar contraseña -->
        <div class="flex w-full flex-col gap-1">
          <label for="confirmPassword" class="text-label text-neutral-700">
            {{ tForms('input_confirm_psw') }}
          </label>
          <div
            class="recover-input-wrap"
            [class.recover-input-error]="form.hasError('mismatch') && form.get('confirmPassword')?.touched"
          >
            <mat-icon class="recover-input-icon" aria-hidden="true">lock_outline</mat-icon>
            <input
              id="confirmPassword"
              class="recover-input"
              [type]="showPassword() ? 'text' : 'password'"
              formControlName="confirmPassword"
              [placeholder]="tForms('confirm_psw_placeholder')"
              autocomplete="off"
            />
          </div>
          @if (form.hasError('mismatch') && form.get('confirmPassword')?.touched) {
            <p class="text-label text-error-600">{{ tMsg('error_not_match') }}</p>
          }
        </div>

        @if (errorMessage()) {
          <p class="text-label text-error-600">{{ errorMessage() }}</p>
        }

        <div class="flex w-full min-w-0 items-center justify-between gap-3">
          <button
            type="button"
            class="shrink-0 rounded-[4px] border border-error-200 bg-error-50 px-[16px] py-[10px] text-button text-error-600 transition-colors duration-200 hover:bg-error-100 active:bg-error-200"
            (click)="goBack()"
          >
            {{ tBtn('button_cancel') }}
          </button>
          <button
            type="button"
            class="recover-btn-primary shrink-0 rounded-[4px] px-[16px] py-[10px] text-button text-white transition-opacity duration-200"
            [style.background-color]="primaryColor()"
            [disabled]="form.invalid"
            [class.opacity-50]="form.invalid"
            [class.cursor-not-allowed]="form.invalid"
            (click)="!form.invalid && submit()"
            (keydown.enter)="!form.invalid && submit()"
          >
            {{ tProfile('change_password_title') }}
          </button>
        </div>
      </form>

    } @else {

      <div class="flex flex-col items-center justify-center gap-4 py-10">
        <p class="text-body-bold text-neutral-700">{{ tMsg('processing_request') }}</p>
        <p-progressSpinner class="h-10 w-10" />
      </div>

    }

  </div>
</main>
